import { cadenceShort, routeShort, stockLabel } from './medicationFormat'
import MedicationStockButton from './MedicationStockButton'

function MedicationRxItem({ item, canEdit, onEdit, onSuspend, onReload }) {
  const useLabel = item.end_date ? 'Ativo' : 'Uso contínuo'
  return (
    <article className="med-rx-item">
      <div className="med-rx-item-main">
        <p className="med-rx-title">
          <strong>{item.name}</strong>
          <span> ({routeShort(item.route)}, {cadenceShort(item)})</span>
          <span className={`med-use${item.end_date ? '' : ' is-continuous'}`}>{useLabel}</span>
        </p>
        <p className="patients-muted">Prescrito: {item.prescribed_by_name || 'não informado'}</p>
        {canEdit && (
          <div className="med-rx-links">
            <button type="button" onClick={() => onEdit(item)}>Editar</button>
            <button type="button" onClick={() => onSuspend(item)}>Suspender</button>
          </div>
        )}
      </div>
      <div className="med-rx-stock">
        <strong className={item.stock_level === 'low' ? 'is-low' : item.stock_level === 'empty' ? 'is-empty' : ''}>{stockLabel(item)}</strong>
        {canEdit && <MedicationStockButton onReload={(quantity) => onReload(item, quantity)} />}
      </div>
    </article>
  )
}

export default MedicationRxItem
